import * as React from 'react'
import colors from '../../../theme/colors'
import type { Color } from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const UserSvg = ({ width, height, color }: Props) => {
  const newWidth = width || 0
  const newHeight = height || 0
  const viewBox = `0 0 ${newWidth} ${newHeight}`
  const transform = `translate(${newWidth / 4} ${newHeight / 4})`

  return (
    <svg width={newWidth} height={newHeight} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
        fill="#FFF5DA"
      />
      <g clipPath="url(#clip0_176_264)">
        <path
          d="M16.0081 16C18.4143 16 20 14.24 20 12C20 9.76 18.4143 8 16.0081 8C13.602 8 12 9.76 12 12C12 14.24 13.602 16 16.0081 16ZM24 23.04C22.8829 18.96 18.4143 16.4 14.0317 17.44C11.1099 18.16 8.78969 20.24 8.01628 23.04C7.93035 23.44 8.18815 23.92 8.70376 24C8.78969 24 8.87562 24 8.87562 24H23.1407C23.6563 24 24 23.68 24 23.2C24 23.12 24 23.04 24 23.04Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_176_264">
          <rect width={newWidth / 2} height={newHeight / 2} fill="white" transform={transform} />
        </clipPath>
      </defs>
    </svg>
  )
}

UserSvg.defaultProps = {
  width: 32,
  height: 32,
  color: colors.Primary.yellow500
}

export default UserSvg
